export default {
    mounted() {
        this.setLocale();
    },
    computed: {
        country() {
            let country = "us"
            if (this.globalSettings && this.globalSettings.country) {
                country = this.globalSettings.country
            }
            return country.toUpperCase();
        },
    },
    methods: {
        setLocale() {
            if (this.globalSettings && typeof this.globalSettings.language === "string") {
                this.$root.$i18n.locale = this.globalSettings.language;
            }
        },
    },

}